import Password from './component';

export default Password;
